import { useAppSelector } from "@src/reduxStore";
import { FC } from "react";
import { useIntl } from "react-intl";

const LinkToLk2Service: FC = ({ children }) => {
  const config = useAppSelector(state => state.common.config);
  const intl = useIntl();

  return (
    <b>
      <a
        href={intl.formatMessage(
          {
            id: "lk2ServiceUrl",
            defaultMessage: "{lk2Url}/?recommend=true",
          },
          {
            lk2Url: config?.lk2Url,
          }
        )}
        target="_blank"
        rel="noreferrer noopener"
      >
        {children}
      </a>
    </b>
  );
};

export default LinkToLk2Service;
